// Render Markdown MÍNIMO e seguro para as bolhas do assistente.
// Suporta apenas: links [texto](url), **negrito** e texto. SEM innerHTML — o template
// itera os segmentos e usa binding seguro do Angular. URLs restritas a http/https.

export type SegmentoTexto = {
  tipo: 'texto' | 'link' | 'negrito';
  texto: string;
  href?: string;
};

/** Retorna a URL apenas se o esquema for http/https; caso contrário null. */
export function urlSegura(url: string): string | null {
  const t = (url ?? '').trim();
  return /^https?:\/\//i.test(t) ? t : null;
}

// Um link [texto](url) OU um trecho **negrito**. Capturamos ambos numa varredura única.
const PADRAO = /\[([^\]]+)\]\(([^)\s]+)\)|\*\*([^*]+)\*\*/g;

/** Quebra o texto em segmentos (texto/link/negrito) para render seguro. */
export function renderizarSegmentos(texto: string): SegmentoTexto[] {
  const src = texto ?? '';
  const segmentos: SegmentoTexto[] = [];
  let ultimo = 0;
  let m: RegExpExecArray | null;

  PADRAO.lastIndex = 0;
  while ((m = PADRAO.exec(src)) !== null) {
    if (m.index > ultimo) {
      segmentos.push({ tipo: 'texto', texto: src.slice(ultimo, m.index) });
    }

    if (m[1] !== undefined) {
      // link markdown
      const href = urlSegura(m[2]);
      if (href) {
        segmentos.push({ tipo: 'link', texto: m[1], href });
      } else {
        // esquema inseguro → mantém como texto puro (sem link)
        segmentos.push({ tipo: 'texto', texto: m[0] });
      }
    } else if (m[3] !== undefined) {
      segmentos.push({ tipo: 'negrito', texto: m[3] });
    }

    ultimo = m.index + m[0].length;
  }

  if (ultimo < src.length) {
    segmentos.push({ tipo: 'texto', texto: src.slice(ultimo) });
  }

  return segmentos.length > 0 ? segmentos : [{ tipo: 'texto', texto: src }];
}
